// Global
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
//import { useTheme } from 'lib/context/ThemeContext';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
// Components
import Component from 'src/helpers/Component/Component';
import Head from 'next/head';
import { getEnum } from 'lib/utils/get-enum';
import { ThreekitVisualizerTheme } from './ThreekitVisualizer.theme';
import classNames from 'classnames';
import { useTheme } from 'lib/context/ThemeContext';
import { useEffect, useRef } from 'react';

export type ThreekitVisualizerProps =
  Feature.EnterpriseWeb.RenewalByAndersen.Components.Product.ThreekitVisualizer;
const ThreekitVisualizer = (props: ThreekitVisualizerProps) => {
  const { themeData } = useTheme(ThreekitVisualizerTheme);
  const isLoading = useRef<boolean>();

  useEffect(() => {
    if (!isLoading.current) {
      isLoading.current = true;
    } else {
      return;
    }

    // @ts-ignore threekit recommendation
    if (window.threekit) {
      // @ts-ignore threekit recommendation
      delete window.threekit;
    }

    const script = document.createElement('script');
    script.src = props.fields.scriptSrc?.value;
    script.async = true;
    script.onload = () => {
      isLoading.current = false;
    };
    document.body.appendChild(script);
  }, []);

  if (!props.fields) {
    return <></>;
  }
  const productId = getEnum<string>(props.fields.productId);
  return (
    <>
      <Head>
        <link href={props.fields.cssHref?.value} rel="stylesheet" />
      </Head>
      <Component variant="lg" dataComponent="product/threekitvisualizer" {...props}>
        {productId && <input type="hidden" id="productId" value={productId} />}
        <div
          className={classNames(themeData.classes.body, 'tk-treble-app')}
          id="tk-treble-root"
        ></div>
      </Component>
    </>
  );
};

export default withDatasourceCheck()<ThreekitVisualizerProps>(ThreekitVisualizer);
